<template>
    <div class="checklist-inspection-form-header">
        <div class="checklist-inspection-form-header-card">
            <div class="checklist-inspection-form-header-card-employee">
                <EmployeeCard 
                    :firstName="employee?.firstName"
                    :lastName="employee?.lastName"
                    :position="employee?.position"
                    :photoUrl="employee?.photoUrl"
                    :showAvailability="true"
                    :hideAvailabilitySelector="true"
                    :showImportanceSelector="false"
                    :isHoverEnabled="false"
                />
            </div>
            <div class="checklist-inspection-form-header-card-responsibility">
                <ResponsibilityAssignmentCard 
                    :responsibilityCode="cleanResponsibilityCode"
                    :responsibilityName="responsibility?.responsibilityName"
                    :roleCode="cleanRoleCode"
                    :roleName="responsibility?.roleName"
                    :positionCode="cleanPositionCode"
                    :positionName="responsibility?.positionName"
                    :responsibilityImportance="responsibility?.responsibilityImportance"
                    :roleImportance="responsibility?.roleImportance"
                    :positionImportance="responsibility?.positionImportance"
                    :positionCommitment="responsibility?.positionCommitment"
                    :assignedOn="responsibility?.assignedOn"
                    :newDuration="responsibility?.newDuration"
                    :show_codes="responsibility?.show_codes"
                />
            </div>
        </div>
        <div class="checklist-inspection-form-header-card-actions">
            <IssueBadgeAction 
                :dot="dot"
                :currentBadge="currentBadge"
                :readyForLevel="readyForLevel"
                @badge-selected="handleBadgeSelection"
            />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import EmployeeCard from '@components/organizations/employees/EmployeeCard/EmployeeCard.vue';
import ResponsibilityAssignmentCard from '@components/ResponsibilityAssignmentCard/ResponsibilityAssignmentCard.vue';
import IssueBadgeAction from '@components/IssueBadgeAction/IssueBadgeAction.vue';

const props = defineProps({
    employee: {
        type: Object,
        required: false,
    },
    responsibility: {
        type: Object,
        required: false,
    },
    dot: {
        type: String,
        required: false,
    },
    currentBadge: {
        type: String,
        required: false,
    },
    readyForLevel: {
        type: String,
        default: null,
    },
});

const emit = defineEmits(['badge-selected']);

const extractCodeNumber = (codeStr) => {
    const match = codeStr?.match(/#(\d+)/);
    return match ? match[1] : null;
};

const cleanResponsibilityCode = computed(() => {
    const rawCode = props.responsibility?.responsibilityCode;
    const cleanCode = extractCodeNumber(rawCode);
    return cleanCode ? `#${cleanCode}` : rawCode;
});

const cleanRoleCode = computed(() => {
    const rawCode = props.responsibility?.roleCode;
    const cleanCode = extractCodeNumber(rawCode);
    return cleanCode ? `#${cleanCode}` : rawCode;
});

const cleanPositionCode = computed(() => {
    const rawCode = props.responsibility?.positionCode;
    const cleanCode = extractCodeNumber(rawCode);
    return cleanCode ? `#${cleanCode}` : rawCode;
});

const handleBadgeSelection = (badgeData) => {
    emit('badge-selected', badgeData);
};
</script>

<style scoped>
.checklist-inspection-form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    width: 100%;
}
.checklist-inspection-form-header-card {
    display: flex;
    gap: 10px;
}
.checklist-inspection-form-header-card-actions {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.checklist-inspection-form-header-card-employee {
    display: flex;
    justify-content: flex-start;
    align-items: start;
    gap: 10px;
}
.checklist-inspection-form-header-card-responsibility {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}
</style>